import { CloseButton } from '@mantine/core'

import DnDrawer from 'src/components/Core/DnDrawer'

import ESignaturesSection from './ESignaturesSection'

type Props = {
  applicantId: string
  opened: boolean
  onClose: () => void
}

/**
 * Where each e-signature request sent to this applicant stands. The section
 * inside only mounts while the drawer is open, so nothing is fetched until a
 * recruiter asks to see it.
 */
const ESignatureStatusDrawer = ({ applicantId, opened, onClose }: Props) => (
  // The table needs more room than the drawer's default 30%
  <DnDrawer
    opened={opened}
    onClose={onClose}
    size="55%"
    stackId="e-signature-status-drawer"
  >
    {opened && (
      // Takes its natural height, so the pagination bar sits right under the
      // rows. Only if that is taller than the window does it scroll (the
      // drawer clips anything that overflows it, and sits a few px inside the
      // viewport, hence the 3rem).
      <div className="flex max-h-[calc(100vh-3rem)] flex-col gap-2 overflow-y-auto">
        <div className="flex justify-end">
          <CloseButton aria-label="Close" onClick={onClose} />
        </div>
        <ESignaturesSection applicantId={applicantId} />
      </div>
    )}
  </DnDrawer>
)

export default ESignatureStatusDrawer
